<template>
    <div>
        <div class="news-list-header">
            <div class="title-subtitle">
                <span class="title">Novidades {{ getInstance(true) }}</span>
                <span class="subtitle">Temos algumas novidades empolgantes para compartilhar com você!</span>
            </div>
            <div class="category-selected">
                <span>Categorias</span>
                <ui-select-2
                    v-model="news.selectedId"
                    :data="category"
                    :search="false"
                    :loading="loader.category"
                    placeholder="Categorias"
                    item-label="name"
                    return-value="id"
                    design="mgb-0 br-default br-all"
                />
            </div>
        </div>
        <ui-overlay-load v-if="loader.news" background-color-overlay="transparent" />
        <section class="news-container-list scroll-color">
            <div v-if="news.list.length == 0 && !loader.moreNews && !loader.news">
                Nenhum item foi encontrado...
            </div>

            <div v-for="(news, index) in news.list" :key="news.id">
                <ui-news-card
                    :id="news.id"
                    :cover="news.cover ? news.cover.url : ''"
                    :title="news.title"
                    :desc="news.article"
					:category-name="news.category.name"
                    :created-at="news.created_at"
					:primaryCard="index == 0"
                />
            </div>

			<ui-modal-message
				name="delete-news-list"
				service="news"
				title="Deseja realmente excluir está novidade?"
				text="Cuidado, esta ação não poderá ser desfeita."
				btn-type="danger"
				btn-text="Confirmar"
				icon="fal fa-trash-alt"
				color-circle="danger"
				icon-circle
			/>
        </section>
        <div v-if="loader.moreNews" class="load-more-news">
            <ui-load-indicator :h="50" color="#69D296" :stroke="8" />
        </div>
    </div>
</template>


<script>
import { uiOverlayLoad, uiLoadIndicator } from '@/components/ui'
import { uiSelect2 } from '@/components/ui/form'
import { uiNewsCard } from '@/components/ui-facilita/news'
import { uiModalMessage } from '@/components/ui/modal'
import * as userGroups from '@/components/ui-facilita/news/util/userGroups.js'

import { storage } from '@/services/storage'
import { news } from '@/services/axios'

import helpers from '@/mixins/helpers'
import { mapGetters } from 'vuex'



const defaultLoader = () => ({ news: true, moreNews: false, category: true })

export default {
	name: 'news-main-views-list',
	components: {
		uiOverlayLoad,
		uiLoadIndicator,
		uiSelect2,
		uiNewsCard,
		uiModalMessage
	},
	mixins: [ helpers ],
	data() {
		return {
			loader: { ...defaultLoader() },
			search: '',
			news: { 
				selectedId: '', 
				currentPage: 1,
				totalPage: 2,
				charging: false,
				list: [] 
			},
			scrollBusy: false,
			noData: false,
			category: []
		}
	},

	computed: {
		...mapGetters('auth', { user: 'getUser' }),
		...userGroups
	},

	watch: {
		async 'news.selectedId' (value) {
			this.noData = false
			this.news.list = []
			this.news.currentPage = 1
			await this.getNews()
		}
	},

	async mounted() {
		this.getCategory()

		if (this.$route.params.category) {
			this.news.selectedId = this.$route.params.category
		} else {
			await this.getNews()
		}
		
		this.$root.$on('news-add', () => {
			this.$router.push({ name: 'news.add' })
		})

		this.$root.$on('set-data-news-deleted-list', (data, id) => {
			this.news.list = this.news.list.filter(val => val.id != id)
			this.$toastr.s("Novidade Excluída!")
		})

		this.$root.$on('scroll-handler', () => {
			this.scrollHandler()
		})
	},

	beforeDestroy() {
		this.$root.$off('news-add')
		this.$root.$off('set-data-news-deleted-list')
		this.$root.$off('scroll-handler')
	},

	methods: {
		async getNews(moreNews = false) {
			try {
				/**
				 * adiciona o load se for do scroll ou do carregamento normal
				 */
				this.loader[moreNews ? 'moreNews' : 'news'] = true
				let id = this.news.selectedId
				if (this.news.selectedId.length == 0 && !moreNews) {
					id = ''
				}
				this.scrollBusy = true
				const response = await news.getAllV2(`?per_page=20&page=${this.news.currentPage}&category=${id}`)

				/**
				 * adiciona o total de paginas e acrecenta mais uma página
				 */
				this.news.totalPage = response.data.last_page
				if(this.news.currentPage <= this.news.totalPage) {
					this.news.currentPage = this.news.currentPage + 1
				}
				
				/**
				 * prepara a lista para mostrar
				 */
				await this.prepareNewsList(response)
				this.news.charging = false
			} catch (e){
				if(e?.message === undefined) {
					return
				}
				this.$toastr.e('Não foi possível carregar as novidades!')
			} finally {
				this.loader.news = false
				this.loader.moreNews = false
				this.scrollBusy = false
			}
		},

		async getCategory() {
			try {
				const response = await news.getAllV2('/category')
				this.category = response.data
			} catch (e){
				if(e?.message === undefined) {
					return
				}
				this.$toastr.e('Não foi possível carregar as categorias de novidade!')

			} finally {
				this.loader.category = false
			}
		},

		prepareNewsList(response) {
			response.data.data.forEach((newsItem) => {
				this.news.list.push(newsItem)
			})
		},

		filterByNameDesc(n) {
			const byName = n.title.toLowerCase().includes(this.search.toLowerCase())
			const byDesc = n.article.toLowerCase().includes(this.search.toLowerCase())
			return byName ? byName : byDesc
		},

		async scrollHandler() {
			if (!this.news.charging) {
				this.news.charging = true
				if(this.news.currentPage <= this.news.totalPage) {
					await this.getNews(true)
				}
			}
		}
	},
}
</script>

<style lang="stylus" scoped>
@import 'styles.styl';
</style>
